import React, { useState } from 'react'
import { Route } from 'react-router'
import { useTranslation } from 'react-i18next'

import {
	DashboardIconNew,
	DashboardLogoutMobile,
	LogoDashboard,
	LogoDashboardTablet,
	LogoDashboardMobile,
	SearchIcon
} from 'media/icons'
import useDeviceType from 'hooks/useDeviceType'
import MenuItem from 'components/MenuItem'
import MainPageSearch from 'components/MainPageSearch'
import { StyledMenuList, StyledHeaderWrapper } from './styled'
import { useWindowSize } from 'hooks/useWindowSize'

const AppHeader = ({ className }) => {
	const [menuVisible, setMenuVisible] = useState(false)
	const [searchVisible, setSearchVisible] = useState(false)

	const toogleMenuVisible = () => {
		setMenuVisible(prev => !prev)
	}

	const toogleSearchVisible = () => {
		setSearchVisible(prev => !prev)
	}

	const [t] = useTranslation()
	const userDevice = useDeviceType()
	const { width } = useWindowSize()
	const notDesktopDevice = userDevice === 'mobile' || userDevice === 'tablet' || width === 1200

	const LogoComponent = userDevice === 'desktop'
		? LogoDashboard : userDevice === 'tablet'
			? LogoDashboardTablet : LogoDashboardMobile

	return (
		<StyledHeaderWrapper>
			<div className='container'>
				<div className='logo_and_menu'>
					<div className={`menu_icon ${menuVisible && 'menu_icon_opened'}`} onClick={toogleMenuVisible}>
						<span/>
					</div>
					{!(searchVisible && notDesktopDevice) && // hide logo when search is open in mobile view
						<div className='logo'>
							<LogoComponent/>
						</div>
					}
					<div className={`${className} menu ${!menuVisible && 'hideMenu'}`} onClick={toogleMenuVisible} >
						<StyledMenuList>
							<div className='menu_list'>
								<MenuItem label='dashboard_section.branch_metrics' link='' icon={DashboardIconNew}/>
							</div>
							{notDesktopDevice && (
								<a href='https://cashassist.hssoft.com/' className='logout_wrapper'>
									<DashboardLogoutMobile />
									<span>{t('common.strings.back_to_homepage')}</span>
								</a>
							)}
						</StyledMenuList>
					</div>
					{notDesktopDevice &&
						<Route exact path='/'>
							<div className={`search ${searchVisible && 'search_opened'}`}>
								<MainPageSearch userDevice={userDevice} />
								<div className='search_icon' onClick={toogleSearchVisible}>
									<SearchIcon />
								</div>
							</div>
						</Route>
					}
				</div>
			</div>
		</StyledHeaderWrapper>
	)
}

export default AppHeader
